import React, { FC, ReactElement, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';

import './SwipeTransition.scss';

type SwipeProps = {
  elements: [ReactElement, ReactElement];
  state: boolean;
  className?: string;
  hide?: boolean;
};

const SwipeTransition: FC<SwipeProps> = ({ elements, state, className = '', hide = false }) => {
  const nodeRef1 = useRef<HTMLDivElement | null>(null);
  const nodeRef2 = useRef<HTMLDivElement | null>(null);

  return (
    <div className={cn('swipe-wrapper', className)}>
      <CSSTransition
        in={state}
        timeout={500}
        classNames={cn(hide ? 'swipe-hide' : 'swipe')}
        unmountOnExit
        nodeRef={nodeRef1}
      >
        <div ref={nodeRef1} className="swipe-box">
          {elements[0] || <p>Element</p>}
        </div>
      </CSSTransition>
      <CSSTransition
        in={!state}
        timeout={500}
        classNames={cn(hide ? 'swipe-hide' : 'swipe')}
        unmountOnExit
        nodeRef={nodeRef2}
      >
        <div ref={nodeRef2} className="swipe-box">
          {elements[1] || <p>Element</p>}
        </div>
      </CSSTransition>
    </div>
  );
};

export default SwipeTransition;
